// src/pages/PesquisaJurisprudencia/components/ResultadosSection.js
import React from 'react';

const ResultadosSection = ({
  resultados,
  paginacao,
  abaAtiva,
  casoSelecionado,
  loading,
  loadingPesquisaCaso,
  loadingIA,
  buscaAtiva,
  tribunaisSelecionados,
  selectedTags,
  textoFiltro,
  descricaoIA,
  onVerMais,
  onMudarPagina,
  formatarData,
  formatarNumero,
  abrirUrlOriginal
}) => {
  const isLoadingAtivo = loading || loadingPesquisaCaso || loadingIA;

  const deveExibirSemResultados = () => {
    if (isLoadingAtivo || resultados.length > 0 || !buscaAtiva) return false;
    if (abaAtiva === 'filtros') {
      return (selectedTags.length > 0 || !!textoFiltro.trim()) && tribunaisSelecionados.length > 0;
    }
    if (abaAtiva === 'caso') return !!casoSelecionado;
    if (abaAtiva === 'ia') return !!descricaoIA?.trim();
    return false;
  };

  const getMensagemSemResultados = () => {
    if (abaAtiva === 'filtros') {
      return `Nenhuma jurisprudência encontrada em ${tribunaisSelecionados.join(', ')} com os filtros aplicados.`;
    }
    if (abaAtiva === 'caso') {
      return `Nenhuma jurisprudência relacionada encontrada para o caso "${casoSelecionado?.name || 'selecionado'}".`;
    }
    return 'Nenhuma jurisprudência encontrada para a descrição informada.';
  };

  const getMensagemLoading = () => {
    if (loadingPesquisaCaso) return 'Analisando caso e encontrando jurisprudência relacionada...';
    if (loading) return `Pesquisando jurisprudência em ${tribunaisSelecionados.join(', ')}...`;
    return null;
  };

  return (
    <>
      {/* Tabela de Resultados */}
      {resultados.length > 0 && (
        <div className="resultados-container">
          <div className="resultados-header">
            <div className="resultados-count">
              {formatarNumero(paginacao.total_records || resultados.length)} resultado(s) encontrado(s)
              {abaAtiva === 'caso' && casoSelecionado && (
                <span> para o caso "{casoSelecionado.name || `Caso ${casoSelecionado.id}`}"</span>
              )}
            </div>
          </div>

          <table className="tabela-jurisprudencia">
            <thead>
              <tr>
                <th>ID</th>
                <th>Tribunal</th>
                <th>Processo</th>
                <th>Data Acórdão</th>
                <th>Meio Processual</th>
                <th>Decisão</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {resultados.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>
                    <span className={`tribunal-badge ${item.tribunal_origem.toLowerCase()}`}>
                      {item.tribunal_origem}
                    </span>
                  </td>
                  <td>
                    {item.processo_numero ? (
                      <button
                        className="processo-link"
                        onClick={() => abrirUrlOriginal(item.url_original)}
                        title="Clique para abrir o acórdão original"
                      >
                        {item.processo_numero}
                      </button>
                    ) : (
                      <span className="processo-numero">N/A</span>
                    )}
                  </td>
                  <td>
                    <div className="data-acordao">{formatarData(item.data_acordao)}</div>
                  </td>
                  <td>
                    <div className="meio-processual">{item.meio_processual || 'N/A'}</div>
                  </td>
                  <td>
                    <div className="decisao-resumo">{item.decisao || 'N/A'}</div>
                  </td>
                  <td>
                    <button className="botao-ver-mais" onClick={() => onVerMais(item.id)}>
                      VER MAIS
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Paginação — somente aba filtros */}
          {abaAtiva === 'filtros' && paginacao.total_pages > 1 && (
            <div className="paginacao">
              <button
                disabled={paginacao.current_page === 1}
                onClick={() => onMudarPagina(paginacao.current_page - 1)}
              >
                Anterior
              </button>

              {[...Array(paginacao.total_pages)]
                .map((_, i) => (
                  <button
                    key={i + 1}
                    className={paginacao.current_page === i + 1 ? 'ativo' : ''}
                    onClick={() => onMudarPagina(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))
                .slice(
                  Math.max(0, paginacao.current_page - 3),
                  Math.min(paginacao.total_pages, paginacao.current_page + 2)
                )}

              <button
                disabled={paginacao.current_page === paginacao.total_pages}
                onClick={() => onMudarPagina(paginacao.current_page + 1)}
              >
                Próxima
              </button>
            </div>
          )}
        </div>
      )}

      {/* Loading — abas filtros e caso (IA tem banner próprio em IATab) */}
      {(loading || loadingPesquisaCaso) && getMensagemLoading() && (
        <div className="loading">{getMensagemLoading()}</div>
      )}

      {/* Sem resultados */}
      {deveExibirSemResultados() && (
        <div className="sem-resultados">{getMensagemSemResultados()}</div>
      )}

      {/* Aviso inicial aba filtros */}
      {abaAtiva === 'filtros' && tribunaisSelecionados.length === 0 && !buscaAtiva && (
        <div className="aviso-tribunal">
          👆 Selecione pelo menos um tribunal para começar a pesquisa
        </div>
      )}
    </>
  );
};

export default ResultadosSection;